import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import accounting from "accounting";
import classnames from "classnames";
import StandardMoney from "../../../common/StandardMoney";

const removeShopItem = rows => {
  rows.splice(1, 1);
  return rows;
};

const CheckoutSummary = ({
  currency,
  common: { isShopEnabled },
  data,
  //derived props - next maintainer should convert to HOCs with recompose's mapProps
  data: {
    payment: {
      employer: { numericValue: paymentEmployerNumericValue } = {},
      employee: { numericValue: paymentEmployeeNumericValue } = {},
    } = {},
    purchaseBreakdown: {
      benefitsPurchase: { numericValue: benefitsPurchaseNumericValue } = {},
      wellnessPurchase: { numericValue: wellnessPurchaseNumericValue } = {},
      benefitsOverPurchase: { numericValue: benefitsOverPurchaseNumericValue } = {},
      wellnessOverPurchase: { numericValue: wellnessOverPurchaseNumericValue } = {},
    } = {},
  } = data,
  _rows = [
    {
      title: messages.riskAndMedicalDescription,
      extraCurrencyClass: "apl-payment__price",
      amount: accounting.unformat(benefitsPurchaseNumericValue),
    },
    {
      title: messages.healthAndWellnessDescription,
      amount: accounting.unformat(wellnessPurchaseNumericValue),
    },
    {
      title: messages.employerPaysDescription,
      extraRowClass: "apl-payment-summary__payments",
      amount: accounting.unformat(paymentEmployerNumericValue),
    },
    {
      title: messages.employeePaysDescription,
      amount: accounting.unformat(paymentEmployeeNumericValue),
    },
    {
      title: messages.totalPayableDescription,
      extraRowClass: "apl-payment-summary__total",
      amount:
        accounting.unformat(benefitsOverPurchaseNumericValue) +
        accounting.unformat(wellnessOverPurchaseNumericValue),
    },
  ],
  // Temporary revert back the initial fix. Needs to relook the logic that was implemented (APL-3038)
  // rows = isShopEnabled || isExternalShopEnabled ? _rows.slice(0) : _rows.slice(1, 2),
  rows = _rows,
}) =>
  !!(data.payment && data.purchaseBreakdown) && (
    <section className="apl-payment-summary">
      <table>
        <tbody>
          {rows.map(({ title, extraRowClass = "", extraCurrencyClass = "", amount }, i) => (
            <tr key={`summary${i}`} className={extraRowClass}>
              <td>
                <FormattedMessage {...title} />
              </td>
              <td className={classnames("apl-field__currency", extraCurrencyClass)}>
                <StandardMoney value={amount} currency={currency} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );

CheckoutSummary.propTypes = {
  data: PropTypes.object.isRequired,
  common: PropTypes.object,
  currency: PropTypes.string,
  _rows: PropTypes.array,
  rows: PropTypes.array,
};

export default CheckoutSummary;



// WEBPACK FOOTER //
// ./components/employee/shop/checkout/CheckoutSummary.js